import React           from 'react';
import { generateKey } from '../../../utils/CommonUtils';
import Translations    from '../../../utils/Translations';
import Languages from '../../Grid2/Tiles/Base/Badges/Languages';

const ActorProfileBadges = (props) => {

    const { isLivePreviewEnabled, isChatQualityHD, isStar, spokenLanguages } = props;

    return (
        <div className='actor-profile-header__badges'>

            {isLivePreviewEnabled && <span className='badge--normal h-left'>{Translations.get('actor_profile.header-badge.livepreview')}</span>}
            {isChatQualityHD && <span className='badge--normal h-left'>{Translations.get('actor_profile.header-badge.hd')}</span>}
            {isStar && <span className='badge--highlight h-left'>{Translations.get('actor_profile.header-badge.star')}</span>}


            <Languages spokenLanguages={props.spokenLanguages} name={"profile"} />
        </div>
    )
}

export default ActorProfileBadges
